import { MedplumClient, ProfileResource } from '@medplum/core'
import { Patient, Practitioner } from '@medplum/fhirtypes'
import { formatProviderName } from '@/utils/providerUtils'

export type ChartVisitContext = {
  practitionerId: string
  practitionerDisplay: string
  organizationId: string
  projectId: string
}

export function formatPractitionerDisplay(practitioner: Practitioner): string {
  return formatProviderName(practitioner.name?.[0])
}

function asPractitioner(profile: ProfileResource | undefined): Practitioner | undefined {
  if (profile?.resourceType !== 'Practitioner') {
    return undefined
  }
  return profile
}

export async function resolveChartVisitContext(
  medplum: MedplumClient,
  patient: Patient,
): Promise<ChartVisitContext> {
  if (!patient.id) {
    throw new Error('Patient id is required')
  }

  const practitioner = asPractitioner(medplum.getProfile())
  if (!practitioner?.id) {
    throw new Error('Practitioner profile is required to create an encounter')
  }

  const projectId = medplum.getProject()?.id
  if (!projectId) {
    throw new Error('Project not found')
  }

  const practitionerRole = await medplum.searchOne(
    'PractitionerRole',
    `practitioner=Practitioner/${practitioner.id}`,
  )
  const organizationId = practitionerRole?.organization?.reference?.split('/')[1]
  if (!organizationId) {
    throw new Error('Organization not found for practitioner')
  }

  return {
    practitionerId: practitioner.id,
    practitionerDisplay: formatPractitionerDisplay(practitioner),
    organizationId,
    projectId,
  }
}
